<ul class="thead text">
    <li>{{ "operation.table.header.Item" | translate }}</li>
    <li class="center">{{ "alarm.table.header.status" | translate }}</li>
    <li class="center">{{ "operation.table.header.action" | translate }}</li>
    <li class="table-icon fill-half">
        <mat-icon
            svgIcon="refresh"
            class="reset-btn"
            (click)="emitRefresh()"
        ></mat-icon>
        <img
            class="sort-btn"
            src="assets/icons/sort.svg"
            (click)="onOccurrenceTimeSortClicked()"
        />
    </li>
</ul>
